/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {KMDSound} from "../sound/KMDSound";
import {KennethMustDie} from "../KennethMustDie";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class KMDIntroConfig implements GameIntroViewConfig {

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0.4, //Default 0.4
            bulletColor: 0xffffff, //Default 0xffffff

        },
        stampColor: 0xFFFFFF
    };

    stampConfig: StampConfig = {
        xBet: true,
        xWays: true,
        xNudge: true,
        xHole: true,
        volatility: Volatility.EXTREME
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];
    continueButtonClickSound: string = KMDSound.LOADER_CONTINUE_BUTTON; // #247

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader: ImgLoader = new ImgLoader(NolimitApplication.resourcePath);

        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("introDiv", "resources/images/Intro_Divider.png");
        imgLoader.add("m1M2AndSpecialReel", "resources/images/special_reel_multiplier.png");
        imgLoader.add("s1AndS2Feature", "resources/images/s2_change_feature.png");
        imgLoader.add("xHole", "resources/images/xhole.png");
        imgLoader.add("xHoleBlur", "resources/images/xhole_blur.png");
        imgLoader.add("fsCfs", "resources/images/Intro_fs.png");
        imgLoader.add("sfs", "resources/images/Intro_sfs.png");
        imgLoader.add("logo", "resources/images/introLogo.png");
        imgLoader.add("preIntro1", "resources/images/pre_intro_images/pre_intro_1.png");
        imgLoader.add("preIntro2", "resources/images/pre_intro_images/pre_intro_2.png");
        for (let i: number = 3; i < 18; i++) {
            imgLoader.add("preIntroGlitch" + i, "resources/images/pre_intro_images/flicker/glitch_effect_000" + (i < 10 ? "0" : "") + i + ".png");
        }

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        topSprite.anchor.set(0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5);
        this.logo.addChild(logoSprite);

        this.pages = [
            new SlideShowPage(ImgLoader.getImgTexture("xHole")),
            new SlideShowPage(ImgLoader.getImgTexture("m1M2AndSpecialReel")),
            new SlideShowPage(ImgLoader.getImgTexture("s1AndS2Feature")),
            new SlideShowPage(ImgLoader.getImgTexture("fsCfs")),
            new SlideShowPage(ImgLoader.getImgTexture("sfs"))
        ];

        // #477
        if (KennethMustDie.apiPlugin.gameClientConfiguration.isSet) {
            if (KennethMustDie.apiPlugin.gameClientConfiguration.useCensoredGfx || KennethMustDie.apiPlugin.gameClientConfiguration.useCensoredGfxUS) {
                (this.pages[0].children[0] as PIXI.Sprite).texture = ImgLoader.getImgTexture("xHoleBlur");
            }
        } else {
            KennethMustDie.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (KennethMustDie.apiPlugin.gameClientConfiguration.useCensoredGfx || KennethMustDie.apiPlugin.gameClientConfiguration.useCensoredGfxUS) {
                    (this.pages[0].children[0] as PIXI.Sprite).texture = ImgLoader.getImgTexture("xHoleBlur");
                }
            });
        }

        this.pages.forEach((page: SlideShowPage) => {
            (page.children[0] as PIXI.Sprite).anchor.x = 0.5;
        });
    }
}